import React from 'react'
import './loadscheddingblock.scss'

const pad = (value) => String(value).padStart(2, '0');

/**
 * LoadSheddingBlock Component
 *
 * Displays load shedding status for a specific hour (4 x 15-min slots).
 * Hour 01 = 00:00–01:00 … Hour 24 = 23:00–24:00
 */
const LoadScheddingBlock = ({ lightStatus, number, isCurrent = false }) => {
    const tone =
        lightStatus === 0 ? 'on' :
        lightStatus === 1 ? 'off' :
        'unknown';

    const hourNum = Number(number) || 1;
    const startHour = hourNum - 1;
    const endHour = hourNum === 24 ? 24 : hourNum;
    const rangeLabel = `${pad(startHour)}:00–${pad(endHour)}:00`;
    const slotLabels = [
        `${pad(startHour)}:00`,
        `${pad(startHour)}:15`,
        `${pad(startHour)}:30`,
        `${pad(startHour)}:45`,
    ];

    return (
        <div
            className={[
                'load-shedding-hour-block',
                `load-shedding-hour-block--${tone}`,
                isCurrent ? 'load-shedding-hour-block--current' : '',
            ].filter(Boolean).join(' ')}
            title={`${rangeLabel}${isCurrent ? ' · Current hour' : ''}`}
        >
            <div className="load-shedding-hour-block__label">
                <span className="load-shedding-hour-block__hour">{rangeLabel}</span>
                {isCurrent && <span className="load-shedding-hour-block__now">Now</span>}
            </div>
            <div className="load-shedding-hour-block__slots">
                {slotLabels.map((label) => (
                    <div
                        key={label}
                        className={`load-shedding-slot load-shedding-slot--${tone}`}
                        title={label}
                    />
                ))}
            </div>
            <div className="load-shedding-hour-block__times">
                {slotLabels.map((label) => (
                    <span key={label}>{label.slice(3)}</span>
                ))}
            </div>
        </div>
    )
}

export default LoadScheddingBlock
